function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Green-Version",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "03_Dashboard_Green",
  transform: "translate(-708.000000, -456.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Zoom",
  transform: "translate(708.000000, 456.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#327954",
  x: 0,
  y: 0,
  width: 32,
  height: 32,
  rx: 5
}), /*#__PURE__*/React.createElement("g", {
  id: "zoom-in",
  transform: "translate(9.000000, 9.000000)",
  stroke: "#FFFFFF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 6.66666667,
  cy: 6.66666667,
  r: 6.66666667
}), /*#__PURE__*/React.createElement("line", {
  x1: 15,
  y1: 15,
  x2: 11.375,
  y2: 11.375,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 6.66666667,
  y1: 4.16666667,
  x2: 6.66666667,
  y2: 9.16666667,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 4.16666667,
  y1: 6.66666667,
  x2: 9.16666667,
  y2: 6.66666667,
  id: "Path"
})))));

function SvgZoom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7C390854-4FF0-4C19-909B-8CB566C4DE01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.30e7b673.svg";
export { ForwardRef as ReactComponent };